// lib
import React from "react";
import PropTypes from "prop-types";
import { Draggable } from "react-beautiful-dnd";
// src
import { PresetType } from "config/constants";
import EditableLine from "../EditableLine";
import CategoryLine from "./CategoryLine";

const DraggableGroup = ({
  // parent props
  group,
  dispatch,
}) => {
  const [parent] = group;
  const className = parent.type === PresetType.CATEGORY ? "group" : "";

  return (
    <div className={className}>
      {group.map((item) => (
        <Draggable key={item.id} draggableId={item.id} index={item.index}>
          {(provided, snapshot) => {
            const cn = snapshot.isDragging ? "dragged" : "";
            return (
              <div ref={provided.innerRef} {...provided.draggableProps} className={cn}>
                {item.type === PresetType.CATEGORY ? (
                  <div {...provided.dragHandleProps}>
                    <CategoryLine category={item} />
                  </div>
                ) : (
                  <EditableLine preset={item} draggable={provided} dispatch={dispatch} />
                )}
              </div>
            );
          }}
        </Draggable>
      ))}
    </div>
  );
};

DraggableGroup.propTypes = {
  // parent props
  group: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  provided: PropTypes.object.isRequired,
};

export default DraggableGroup;
